import { render, staticRenderFns } from "./xjgs.vue?vue&type=template&id=44e4065a&scoped=true"
import script from "./xjgs.vue?vue&type=script&lang=js"
export * from "./xjgs.vue?vue&type=script&lang=js"
import style0 from "./xjgs.vue?vue&type=style&index=0&id=44e4065a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4065a",
  null
  
)

export default component.exports